import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Status, DefaultTopLevelGroup } from "../../../../common/constants";
import { saveQuickAlertsOrderUrl } from "../../../../config";
import { RootState } from "../../../../store";
import api from "../../../../api";

export const SAVE_ALERT_ORDER = "saveQuickAlertsOrder";

const initialState = {
  status: Status.IDLE,
  error: null,
};

export const saveQuickAlertsOrderData = createAsyncThunk(
  SAVE_ALERT_ORDER,
  async (alertOrder: string[]) => {
    try {
      const url: string = `${saveQuickAlertsOrderUrl}?orgId=${DefaultTopLevelGroup.ID}`;
      const response = await api.post(url, {
        alertOrder,
      });
      const quickAlertsOrderedData = response.data;
      return quickAlertsOrderedData;
    } catch (error) {
      throw error;
    }
  }
);

const saveQuickAlertsOrderSlice = createSlice({
  name: SAVE_ALERT_ORDER,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(saveQuickAlertsOrderData.pending, (state) => {
        state.status = Status.PENDING;
      })
      .addCase(saveQuickAlertsOrderData.fulfilled, (state) => {
        state.status = Status.SUCCESS;
      })
      .addCase(saveQuickAlertsOrderData.rejected, (state, action) => {
        state.status = Status.FAILED;
        state.error = action.error.message || null;
      });
  },
});

export const selector = (state: RootState) => state.saveQuickAlertsOrderApi;

export const reducer = saveQuickAlertsOrderSlice.reducer;
